<div class="select-previous-certification">
  <app-dialog-header (dialogHeaderClose)="close()">
    <div class="select-previous-certification__title">
      {{ 'BOOKS.FOOD_CERTIFICATION.SELECT_PREVIOUS_CERTIFICATION' | translate }}
    </div>
  </app-dialog-header>
  <section
    [appLoading]="isLoading"
    [appLoadingType]="eLoadingType.THREE_SQUARES"
  >
    <qima-input-text
      class="select-previous-certification__search-input"
      [(ngModel)]="queryParams.keyword"
      [qimaInputTextPlaceholder]="'COMMON.SEARCH' | translate"
      [qimaInputTextIconLeftName]="qimaIcon.iconName.SEARCH"
      [qimaInputTextSize]="qimaInput.inputSize.LARGE"
      (keydown.enter)="onSearchEnter()"
      (qimaInputTextClearButtonClick)="onSearchClear()"
    ></qima-input-text>
    <div
      class="select-previous-certification__table"
      [class.select-previous-certification__table--disabled]="notFoundControl.value"
    >
      <app-data-table
        (dataTableIsLoading)="onLoadingChange($event)"
        (dataTableRowClick)="tableRowClick($event)"
        (dataTablePaginationChange)="onPaginationChange($event)"
        (dataTablePageSizeChange)="onPageSizeChange($event)"
        (dataTableTableBackendSort)="onSortClick($event)"
        dataTableEmptyMessage="BOOKS.FOOD_CERTIFICATION.NO_PREVIOUS_CERTIFICATION"
        [dataTableActivePage]="activePage"
        [dataTableHeaders]="tableHeaders"
        [dataTableUrl]="dataTableUrl"
        [dataTableBeforeRowClick]="beforeTableRowClick"
        [dataTableHasSelectedBackgroundColor]="true"
        [dataTableHasGlobalLoading]="false"
        [dataTableIsPaginationVisible]="true"
        [dataTablePageSizes]="pageSizes"
        [dataTableTransformSourceData]="transformSourceData"
        [dataTableTop]="0"
        [dataTableBottom]="0"
      ></app-data-table>
    </div>
    <div class="select-previous-certification__footer">
      <qima-divider [qimaDividerOrientation]="qimaDivider.orientation.HORIZONTAL"></qima-divider>
      <div class="select-previous-certification__footer__container">
        <div class="select-previous-certification__footer__container__checkbox">
          <label class="select-previous-certification__footer__container__checkbox-label">
            <input
              type="checkbox"
              [formControl]="notFoundControl"
            />
            <span>{{ 'BOOKS.FOOD_CERTIFICATION.I_DO_NOT_FIND_PREVIOUS_CERTIFICATION' | translate }}</span>
          </label>
        </div>
        <div class="select-previous-certification__footer__container__buttons">
          <qima-button
            [qimaButtonLabel]="'COMMON.CANCEL' | translate"
            [qimaButtonStyle]="qimaButton.buttonStyle.TERTIARY"
            [qimaButtonSize]="qimaButton.buttonSize.LARGE"
            (qimaButtonClick)="onCancel()"
          ></qima-button>
          <qima-button
            class="select-previous-certification__footer__container__buttons__done"
            [qimaButtonLabel]="'BOOKS.FOOD_CERTIFICATION.DONE' | translate"
            [qimaButtonIsDisabled]="!tableSelectRow && !notFoundControl.value"
            [qimaButtonSize]="qimaButton.buttonSize.LARGE"
            [qimaButtonWidth]="qimaButton.buttonWidth.FULL"
            (qimaButtonClick)="onDone()"
          ></qima-button>
        </div>
      </div>
    </div>
  </section>
</div>
